const serverUrl = process.env.REACT_APP_SERVER_URL;

const addZero = (number) => {
	const newNumber = number.toString();
	if (newNumber.length === 1) {
		return "0".concat(newNumber);
	}
	return newNumber;
};

const getCurrentDateInDefaultFormat = () => {
	// MM/DD/YYYY
	const currentDate = new Date();
	return `${addZero(currentDate.getMonth() + 1)}/${addZero(
		currentDate.getDate()
	)}/${currentDate.getFullYear()}`;
};

const formatNumber = (number) => {
	if (number) {
		const split = number.toString().split(".");
		return (
			split[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
			(split[1] ? "," + split[1].slice(0, 2) : "")
		);
	}
	return "";
};

const formatDate = (date) => {
	return new Date(date).toLocaleDateString();
};

const formatDateSimple = (date = "", transform = false) => {
	const formattedDate = (date || "").split("T")[0];
	if (transform) {
		const splitted = formattedDate.split("-");
		return `${splitted[1]}/${splitted[2]}/${splitted[0]}`;
	}
	return formattedDate;
};

const getCurrentDateKey = () => {
	const currentDateString = new Date()
		.toLocaleDateString("en-US", {
			timeZone: "America/Bogota",
			year: "numeric",
			month: "numeric",
		})
		.split("/");
	return currentDateString[1] + "-" + currentDateString[0];
};

const getDateKey = (date) => {
	if (!date) return "";
	const currentDateString = date
		.toLocaleDateString("en-US", {
			timeZone: "America/Bogota",
			year: "numeric",
			month: "numeric",
		})
		.split("/");
	return currentDateString[1] + "-" + addZero(currentDateString[0]);
};

const getDateInFormat = (date) => {
	if (!date) return "";
	return (
		date.toISOString().slice(0, 7) +
		` (${date.toLocaleString("es-ES", { month: "short" }).toLowerCase()})`
	);
};

const formatDateToTime = (date) => {
	return new Date(date).toLocaleTimeString();
};

const stringToDateNewFormat = (date) => {
	const newDate = stringToDate(date);
	return getDeliveryDateDetails(newDate);
};

const stringToDate = (date, end) => {
	const dateArray = date.split("-");
	return new Date(
		Number(dateArray[0]),
		Number(dateArray[1]) - 1,
		Number(dateArray[2]),
		end ? 23 : 0,
		end ? 59 : 0,
		end ? 59 : 0
	);
};

const getDeliveryDateDetails = (date) => {
	return new Intl.DateTimeFormat("es", {
		weekday: "long",
		day: "numeric",
		month: "long",
		year: "numeric",
	}).format(new Date(date));
};

const getLastUpdatedDate = (date) => {
	return new Intl.DateTimeFormat("es", {
		weekday: "long",
		day: "numeric",
		month: "long",
		year: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
	}).format(new Date(date));
};

const dateToInputFormat = (date) => {
	const dateArray = date.toLocaleDateString().split("/").reverse();
	return (
		dateArray[0] + "-" + addZero(dateArray[1]) + "-" + addZero(dateArray[2])
	);
};

const getStartRangeDate = () => {
	const currentDate = new Date();
	const baseDate =
		currentDate.getFullYear() + "-" + addZero(currentDate.getMonth() + 1);
	return {
		startDate: baseDate + "-01",
		endDate:
			baseDate +
			"-" +
			addZero(
				new Date(
					currentDate.getFullYear(),
					currentDate.getMonth() + 1,
					0
				).getDate()
			),
	};
};

const downloadFile = (fileUrl, fileName, local = false) => {
	const downloadLink = document.createElement("a");
	if (local) {
		downloadLink.href = fileUrl;
	} else {
		downloadLink.href = serverUrl + fileUrl;
	}
	downloadLink.download = fileName;
	downloadLink.target = "_blank";
	downloadLink.dispatchEvent(
		new MouseEvent("click", {
			bubbles: true,
			cancelable: true,
			view: window,
		})
	);
	downloadLink.remove();
};

const stringArrayToSelectOptions = (stringArray) => {
	return stringArray.map((value) => ({
		value,
		label: value,
	}));
};

const dataArrayToSelectOptions = (dataArray) => {
	return dataArray.map((data) => ({
		value: data._id,
		label: data.name,
	}));
};

const extractSelectedToItems = (selectedItems) => {
	return (
		selectedItems
			?.filter((selected) => selected)
			.map((selected) => selected.value) || []
	);
};

const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);

const calculateTotal = (dates = [], values = {}) =>
	dates.reduce((total, date) => total + (Number(values[date]) || 0), 0);

const dateKeyToDate = (dateKey, day = "01") => {
	if (!dateKey) return null;
	return new Date(`${dateKey}-${day} 00:00:00`);
};

module.exports = {
	addZero,
	dateToInputFormat,
	downloadFile,
	formatDate,
	formatDateSimple,
	formatDateToTime,
	formatNumber,
	getCurrentDateKey,
	getDeliveryDateDetails,
	getLastUpdatedDate,
	getStartRangeDate,
	stringToDate,
	stringToDateNewFormat,
	stringArrayToSelectOptions,
	extractSelectedToItems,
	dataArrayToSelectOptions,
	getCurrentDateInDefaultFormat,
	validateEmail,
	calculateTotal,
	getDateKey,
	dateKeyToDate,
	getDateInFormat,
};
